// A presigned transfer failure must retry that transfer, not resend the file to
// the legacy multipart endpoint. Direct-only servers reject multipart, masking
// the original failure; uncertain transfers must never switch upload protocols.
export async function runUploadTransport({ presignedEnabled, presigned, traditional }) {
  if (presignedEnabled) return presigned();
  // Retain explicitly configured legacy deployments; never select by file size.
  return traditional();
}
